"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransmissionMethodKeysEnum = void 0;
var TransmissionMethodKeysEnum;
(function (TransmissionMethodKeysEnum) {
    TransmissionMethodKeysEnum["FileTransfer"] = "fileTransfer";
    TransmissionMethodKeysEnum["Email"] = "email";
    TransmissionMethodKeysEnum["SiteFlow"] = "siteFlow";
    TransmissionMethodKeysEnum["EnfocusSwitch"] = "enfocusSwitch";
    TransmissionMethodKeysEnum["PromoStandards"] = "promoStandards";
    TransmissionMethodKeysEnum["ApiPoll"] = "apiPoll";
    TransmissionMethodKeysEnum["ApiPush"] = "apiPush";
    TransmissionMethodKeysEnum["Pom"] = "pom";
})(TransmissionMethodKeysEnum = exports.TransmissionMethodKeysEnum || (exports.TransmissionMethodKeysEnum = {}));
